import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaLinkedinIn, FaTiktok } from 'react-icons/fa';

const MarketingPage = () => {
  return (
    <div>
      <section className="hero">
        <div className="container">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'center', minHeight: '80vh' }}>
            {/* Content Section */}
            <div>
              <h1>Benefit Mankind - Mobile App</h1>
              <p>
                The most trusted and impactful way to support humanitarian causes through secure,
                one-time donations. Join thousands of compassionate individuals making a real difference.
              </p>
              <div>
                <a href="#" className="btn" style={{ marginRight: '1rem' }}>
                  📱 Download on App Store
                </a>
                <a href="#" className="btn">
                  📱 Get it on Google Play
                </a>
              </div>
              {/* Navigation Buttons */}
              <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                <Link to="/privacy-policy" className="btn" style={{ backgroundColor: '#6c757d', fontSize: '14px', padding: '8px 16px' }}>
                  Privacy Policy
                </Link>
                <Link to="/support" className="btn" style={{ backgroundColor: '#6c757d', fontSize: '14px', padding: '8px 16px' }}>
                  Support & Help
                </Link>
                <Link to="/delete-account" className="btn" style={{ backgroundColor: '#dc3545', fontSize: '14px', padding: '8px 16px', color: 'white' }}>
                  Delete Account Guide
                </Link>
                <a href="https://benefitmankind.co.uk" target="_blank" rel="noopener noreferrer" className="btn" style={{ backgroundColor: '#6c757d', fontSize: '14px', padding: '8px 16px' }}>
                  Visit Main Website
                </a>
              </div>
            </div>

            {/* Mobile Mockups Section */}
            <div style={{ position: 'relative', height: '500px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              {/* Phone 1 - Left, rotated */}
              <img
                src="/image_1.png"
                alt="Benefit Mankind App Screenshot 1"
                style={{
                  position: 'absolute',
                  width: '200px',
                  height: 'auto',
                  transform: 'rotate(-15deg) translateX(-120px) translateY(-20px)',
                  boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                  borderRadius: '20px',
                  zIndex: 1,
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.transform = 'rotate(-15deg) translateX(-120px) translateY(-20px) scale(1.05)'}
                onMouseOut={(e) => e.target.style.transform = 'rotate(-15deg) translateX(-120px) translateY(-20px) scale(1)'}
              />

              {/* Phone 2 - Center, main focus */}
              <img
                src="/image_2.png"
                alt="Benefit Mankind App Screenshot 2"
                style={{
                  position: 'absolute',
                  width: '220px',
                  height: 'auto',
                  transform: 'rotate(5deg) translateY(10px)',
                  boxShadow: '0 25px 50px rgba(0,0,0,0.4)',
                  borderRadius: '20px',
                  zIndex: 3,
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.transform = 'rotate(5deg) translateY(10px) scale(1.05)'}
                onMouseOut={(e) => e.target.style.transform = 'rotate(5deg) translateY(10px) scale(1)'}
              />

              {/* Phone 3 - Right, rotated */}
              <img
                src="/image_3.png"
                alt="Benefit Mankind App Screenshot 3"
                style={{
                  position: 'absolute',
                  width: '190px',
                  height: 'auto',
                  transform: 'rotate(20deg) translateX(130px) translateY(30px)',
                  boxShadow: '0 15px 35px rgba(0,0,0,0.25)',
                  borderRadius: '20px',
                  zIndex: 2,
                  transition: 'transform 0.3s ease'
                }}
                onMouseOver={(e) => e.target.style.transform = 'rotate(20deg) translateX(130px) translateY(30px) scale(1.05)'}
                onMouseOut={(e) => e.target.style.transform = 'rotate(20deg) translateX(130px) translateY(30px) scale(1)'}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="text-center mb-4">Why Choose Benefit Mankind?</h2>
          <div className="feature-grid">
            <div className="feature-card">
              <div className="feature-icon">⚡</div>
              <h3>Instant Impact</h3>
              <p>
                Your donations reach those in need within 24-48 hours. No delays, no bureaucracy -
                just immediate help where it's needed most.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🎯</div>
              <h3>Targeted Causes</h3>
              <p>
                Choose from carefully vetted humanitarian projects. Every cause is verified,
                transparent, and has measurable impact outcomes.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔍</div>
              <h3>Complete Transparency</h3>
              <p>
                Track exactly how your donation is used with detailed reports, photos, and
                real-time updates from the field.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🛡️</div>
              <h3>Bank-Level Security</h3>
              <p>
                All payments are processed securely through Stripe, a trusted payment processor
                used by millions of businesses worldwide. Your payment details are encrypted
                and stored securely on Stripe's PCI-compliant servers, not ours.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📱</div>
              <h3>User-Friendly Design</h3>
              <p>
                Intuitive interface designed for all ages. Donate in under 30 seconds with
                our streamlined, accessible app experience.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🌍</div>
              <h3>Wide Reach</h3>
              <p>
                From local community projects to international disaster relief -
                your impact makes a real difference where it's needed most.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="impact-stats">
        <div className="container">
          <h2 className="text-center mb-4">Proven Impact</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">£2.5M+</div>
              <p>Total Donations Raised</p>
            </div>
            <div className="stat-card">
              <div className="stat-number">50K+</div>
              <p>Lives Directly Impacted</p>
            </div>
            <div className="stat-card">
              <div className="stat-number">25+</div>
              <p>Countries Supported</p>
            </div>
            <div className="stat-card">
              <div className="stat-number">15K+</div>
              <p>Active Donors</p>
            </div>
            <div className="stat-card">
              <div className="stat-number">200+</div>
              <p>Projects Funded</p>
            </div>
          </div>
        </div>
      </section>

      <section className="features" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          <h2 className="text-center mb-4">App Features</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '3rem', maxWidth: '800px', margin: '0 auto' }}>
            <div>
              <h3>💳 Secure Payment Options</h3>
              <ul>
                <li>Credit & Debit Cards (Visa, Mastercard, Amex)</li>
                <li>Apple Pay & Google Pay</li>
              </ul>
            </div>
            <div>
              <h3>📊 Donation Tracking</h3>
              <ul>
                <li>Real-time donation history</li>

              </ul>
            </div>
            <div>
              <h3>🔔 Project Updates</h3>
              <ul>
                <li>Notifications about new projects</li>
                <li>Project completion updates</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2 className="text-center mb-4">Success Stories</h2>
          <div className="feature-grid">
            <div className="feature-card">
              <h3>🏥 Medical Clinic in Kenya</h3>
              <p>
                "Thanks to 500+ donors, we built a fully equipped medical clinic serving
                10,000+ people in rural Kenya. The app made it so easy to track our progress
                and see the real impact of our donations."
              </p>
              <p><strong>- Sarah M., Donor</strong></p>
            </div>
            <div className="feature-card">
              <h3>🏫 School in Bangladesh</h3>
              <p>
                "Watching the school construction progress through the app was incredible.
                We could see every brick being laid and every child's smile on their first day.
                Transparency like this builds trust."
              </p>
              <p><strong>- James R., Donor</strong></p>
            </div>
            <div className="feature-card">
              <h3>💧 Water Wells in Somalia</h3>
              <p>
                "The real-time updates showed us exactly how our donations were being used.
                Seeing the first clean water flowing from the wells we helped fund was
                incredibly rewarding."
              </p>
              <p><strong>- Maria L., Donor</strong></p>
            </div>
          </div>
        </div>
      </section>

      <section className="impact-stats">
        <div className="container">
          <h2 className="text-center mb-4">Trusted & Registered</h2>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2rem' }}>
            <div style={{ textAlign: 'center', padding: '2rem', backgroundColor: '#f8f9fa', borderRadius: '12px', maxWidth: '300px' }}>
              <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
              <h3>Charity Commission Registered</h3>
              <p>UK Charity #1187849</p>
            </div>
          </div>
        </div>
      </section>

      <section className="cta-section">
        <div className="container">
          <h2 className="mb-3">Ready to Make a Difference?</h2>
          <p className="mb-4">
            Join our community of compassionate donors and start creating positive change today.
            Every donation, no matter the size, makes a real impact.
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="#" className="btn" style={{ backgroundColor: 'white', color: '#007bff' }}>
              🍎 Download on App Store
            </a>
            <a href="#" className="btn" style={{ backgroundColor: 'white', color: '#007bff' }}>
              🤖 Get it on Google Play
            </a>
          </div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2025 Benefit Mankind Charity UK. All rights reserved.</p>
          <p>Benefit Mankind is a UK registered charity 1187849 and UK registered company 12382033.</p>
          <p style={{ marginTop: '1rem' }}>
            <strong>Contact:</strong> <a href="tel:+441254602598" style={{ color: '#007bff', textDecoration: 'none' }}>01254 602598</a> | <a href="mailto:info@benefitmankind.co.uk" style={{ color: '#007bff', textDecoration: 'none' }}>info@benefitmankind.co.uk</a>
          </p>
          <div style={{ marginTop: '1.5rem', display: 'flex', justifyContent: 'center', gap: '2rem', flexWrap: 'wrap' }}>
            <Link to="/privacy-policy" style={{ color: '#007bff', textDecoration: 'none', fontWeight: '500' }}>Privacy Policy</Link>
            <Link to="/support" style={{ color: '#007bff', textDecoration: 'none', fontWeight: '500' }}>Support</Link>
            <Link to="/delete-account" style={{ color: '#007bff', textDecoration: 'none', fontWeight: '500' }}>Delete Account</Link>
            <a href="https://benefitmankind.co.uk" target="_blank" rel="noopener noreferrer" style={{ color: '#007bff', textDecoration: 'none', fontWeight: '500' }}>
              Main Website
            </a>
          </div>

          {/* Social Media Links */}
          <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="http://fb.me/benefitmankinduk" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#1877f2', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(24, 119, 242, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(24, 119, 242, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(24, 119, 242, 0.3)'; }}>
              <FaFacebookF />
            </a>
            <a href="https://twitter.com/Benefit_Mankind" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#1da1f2', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(29, 161, 242, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(29, 161, 242, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(29, 161, 242, 0.3)'; }}>
              <FaTwitter />
            </a>
            <a href="https://www.instagram.com/benefitmankind/" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                background: 'linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(228, 64, 95, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(228, 64, 95, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(228, 64, 95, 0.3)'; }}>
              <FaInstagram />
            </a>
            <a href="https://www.youtube.com/channel/UCH2OM6-bCRyiUWRjfDH1nbA?view_as=subscriber" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#ff0000', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(255, 0, 0, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(255, 0, 0, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(255, 0, 0, 0.3)'; }}>
              <FaYoutube />
            </a>
            <a href="https://uk.linkedin.com/in/benefit-mankind-10317a19b" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#0077b5', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(0, 119, 181, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(0, 119, 181, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(0, 119, 181, 0.3)'; }}>
              <FaLinkedinIn />
            </a>
            <a href="https://www.tiktok.com/@benefitmankind" target="_blank" rel="noopener noreferrer"
              style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: '45px', height: '45px', borderRadius: '50%',
                backgroundColor: '#000000', color: 'white',
                fontSize: '1.2rem', transition: 'all 0.3s ease', textDecoration: 'none',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)'
              }}
              onMouseOver={(e) => { e.target.style.transform = 'scale(1.1)'; e.target.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.4)'; }}
              onMouseOut={(e) => { e.target.style.transform = 'scale(1)'; e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)'; }}>
              <FaTiktok />
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default MarketingPage;
